"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endSpan = exports.startSpan = void 0;
const logger_1 = require("./logger");
const uuid_1 = require("uuid");
class Span {
    constructor(identifier, stream = "default") {
        this.startTime = Date.now();
        this.isOpen = true;
        this.identifier = identifier;
        this.stream = stream;
        this.uuid = uuid_1.v4();
    }
    end() {
        if (!this.isOpen) {
            throw new Error("Span has already been closed");
        }
        return Date.now() - this.startTime;
    }
}
function startSpan(key, stream) {
    return new Span(key, stream);
}
exports.startSpan = startSpan;
function endSpan(span) {
    const duration = span.end();
    return logger_1.log({ identifier: span.identifier, duration, startTime: span.startTime, stream: span.stream, uuid: span.uuid });
}
exports.endSpan = endSpan;
